import React from 'react';
//ICONO CON TOOLTIP
import IconInfo from '../../../Comun/IconInfo/IconInfo';
//ICONOS
import { AccountBalanceOutlined, RoomOutlined, QueryBuilder } from '@material-ui/icons'

const SegundoPaso = (props) => {
    const { establecimientos } = props;
    return (
        <>
            {establecimientos.length === 0 &&
                <b>
                    No salió sorteado en ninguna de las opciones seleccionadas.
                </b>
            }
            {establecimientos.length === 1 &&
                <b>El aspirante ha sido asignado en la siguiente opción:</b>
            }
            {establecimientos.length > 1 &&
                <b>El aspirante ha sido asignado en las siguientes opciones:</b>
            }
            {establecimientos.length > 0 &&
                establecimientos.map((item, i) =>
                    <div key={i + 12} className="ml-2 mt-2 mb-2">
                        <h6>{i + 1}. <b className="text-success"><IconInfo mensaje="Establecimiento" icono={AccountBalanceOutlined} /></b> {item.cueAnexo} - {item.nombre}.</h6>
                        <div className="pl-5">
                            <div><b className="text-success"><IconInfo mensaje="Turno" icono={QueryBuilder} /></b> {item.turno}.</div>
                            <div><b className="text-success"><IconInfo mensaje="Dirección" icono={RoomOutlined} /></b> {item.direccion}.</div>
                            {/*<div><b>Prioridad de Inscripción:</b> {item.prioridad}.</div>*/}
                            <div><b>Número de orden asigando por sorteo:</b> {item.nroOrdenEnElSorteo}<b></b></div>
                            {/*<div><b className="text-success"><IconInfo mensaje="Turno" icono={QueryBuilder} /></b> {item.turno}.</div>
                        <div><b className="text-success"><IconInfo mensaje="Dirección" icono={RoomOutlined} /></b> {item.direccion}.</div>*/}
                        </div>
                    </div>
                )
            }
        </>
    )
}

export default SegundoPaso;